module.exports = __webpack_public_path__ + "static/media/yolo1.56f89242.gif";